<template>
    <div id="admin-referring-physicians" v-observe-visibility="visibilityChanged" style="padding: 8px;height:100%;">
         <Drawer
            v-model="showDetails"
            width="500"
            :mask-closable="false"
            :styles="detailsDrawerStyles">

            <p slot="header"><center>Referring Physician Details</center></p>

            <Row :gutter="20">
                <Form ref="editEntryDetailsFormFields" :model="editEntryDetails" :rules="editEntryDetailsFieldRules" :label-width="130" label-position="right">
                    <FormItem label="Title:">
                        <Select v-model="editEntryDetails.title" style="width:200px" filterable>
                            <Option v-for="item in physicianTitlesRefData" :value="item.title" :key="item.title">{{ item.title }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="Firstname:" prop="firstName" :class="mandatoryFieldsStyle">
                        <Input v-model="editEntryDetails.firstName" ></Input>
                    </FormItem>
                    <FormItem label="Lastname:" prop="lastName" :class="mandatoryFieldsStyle">
                        <Input v-model="editEntryDetails.lastName" ></Input>
                    </FormItem>
                    <FormItem label="Address:" prop="physicianAddress" :class="mandatoryFieldsStyle">
                        <Input v-model="editEntryDetails.physicianAddress" ></Input>
                    </FormItem>
                    <FormItem label="Phone Number:" prop="physicianPhone" :class="mandatoryFieldsStyle">
                        <Input v-model="editEntryDetails.physicianPhone" ></Input>
                    </FormItem>
                    <FormItem label="Fax:">
                        <Input v-model="editEntryDetails.physicianFax" ></Input>
                    </FormItem>
                    <FormItem label="Email:">
                        <Input v-model="editEntryDetails.physicianEmail" ></Input>
                    </FormItem>

                    <FormItem label="Status:">
                        <Select v-model="editEntryDetails.status" style="width:200px" filterable>
                            <Option v-for="item in statusRefData" :value="item.statusCode" :key="item.statusCode">{{ item.statusName }}</Option>
                        </Select>
                    </FormItem>
                    
                </Form>
            </Row>

            <div class="drawer-footer">
                <Button style="margin-right: 8px" @click="handleCancelEntryDetails">Cancel</Button>
                <Button type="success" :loading="savingDetailsToBackend" @click="handleSaveEntryDetails">
                    <span v-if="!savingDetailsToBackend">Save</span>
                    <span v-else>Saving...</span>
                </Button>
            </div>
        </Drawer>
        
        
        <Divider orientation="left">Referring Physicians <span style="font-weight:200">({{ entriesTotalCount }} physicians)</span>
            <Tooltip placement="bottom">
                <Icon type="md-help-circle" color="#4287f5" />
                <div slot="content" style="white-space: normal">
                    <p>This section allows you to manage all the referring physicians for patients you have at your practice.</p>
                    <br />
                    <p>Referring physicians can be created here or via the Patients section.</p>
                    <br />
                    <p>Referring physicians may come and go, retire or become unavailable. In order to remove them from being selected for a patient, simply edit an entry here and change their status to whatever is appropriate.</p>
                    <br />
                    <p>NOTE: Referring Physicians can only be deleted if they are not associated with any patients, otherwise they will be made Inactive.</p>
                </div>
            </Tooltip>
        </Divider>

         <Row :gutter="8" >
            <Button type="primary" @click="handleAddEntry" style="margin-left:8px; margin-right:8px">Add Entry</Button>
            <Button @click="handleEditEntry" style="margin-right:8px">Edit Entry</Button>

            <Poptip
                confirm transfer
                width="300"
                :title="confirmRemoveEntryMessage"
                ok-text="Yes"
                cancel-text="No"
                @on-ok="handleRemoveEntry">
                
                <Button type="error" style="margin-right:8px">Remove Entry</Button>
            </Poptip>

            <!-- <Input v-model="filterFirstnameBy" placeholder="Search by firstname." :clearable="true" style="width: 200px; margin-right:8px" />
            <Input v-model="filterLastnameBy" placeholder="Search by lastname." :clearable="true" style="width: 200px; margin-right:8px" /> -->
            <Input v-model="filterByFirstname" placeholder="First name" :clearable="true" @on-change="throttledSearch" style="width: 300px; margin-right: 8px" />
            <Input v-model="filterByLastname" placeholder="Last name" :clearable="true"  @on-change="throttledSearch" style="width: 300px; margin-right: 8px" />

            <Checkbox v-model="showAllStatusUsers" style="margin-top:6px; margin-right:8px">Include All Status Users</Checkbox>
            
            <Drawer
                v-model="showImportHelp"
                width="500"
                :styles="detailsDrawerStyles">
                    <p slot="header"><center>Import Help</center></p>

                    <div style="margin-left: 20px; margin-right: 20px;">
                            You can bulk import your Referring Physicians by populating the Referring Physician's CSV template file defined below and then using the 'Import…' button<br />
                            <br />
                            <a target="_blank" download :href="referringPhysicianImportTemplateURL">referring_physicians_template.csv</a><br />
                            <br />
                            <b>Referring Physicians import guide:</b><br />
                            <br />
                            <ul id=patientImportGuide>
                                <li>File needs to be of .csv format, remove any special characters</li>
                                <li>Columns can appear in any order but must have the correct column names</li>
                                <li>None of the fields are mandatory</li>
                                <li>If a Referring Physician record has no email address then for a sequential import the software will generate a new record. This could potentially lead to duplicate records, thus it is recommended to do this import only once</li>
                                <li>Records are only updated if all of these fields match: FIRST_NAME, LAST_NAME and EMAIL_ADDRESS</li>
                                <li>Column names cannot be changed, and adding new columns or removing existing columns is not allowed</li>
                                <li>All fields have a maximum field length which if exceeded will cause errors upon import. See below for field length limits: <br/>
                                    &raquo; TITLE (50)<br/>
                                    &raquo; FIRST_NAME (100)<br/>
                                    &raquo; LAST_NAME (255)<br/>
                                    &raquo; ADDRESS (255)<br/>
                                    &raquo; PHONE_NUMBER (30)<br/>
                                    &raquo; FAX(30)</li>
                            </ul>
                    </div>
            </Drawer>

            <Dropdown @on-click="handleImportMenu">
                <Button type="primary">
                    Tools
                    <Icon type="ios-arrow-down"></Icon>
                </Button>
                
                <DropdownMenu slot="list">
                    <DropdownItem name="export-now">
                        Export
                    </DropdownItem>

                    <DropdownItem name="import-now" divided>
                         <Upload
                            multiple
                            name='uploadedFile'
                            :action="uploadActionURL"
                            :data="uploadReferrerImportCSVData"
                            :before-upload="handleBeforeUploadCSV"
                            :format="['csv']"
                            :max-size="2048"
                            :on-format-error="handleFormatError"
                            :on-exceeded-size="handleMaxSize"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            >
                            Import…
                        </Upload>
                    </DropdownItem>
                    
                    <DropdownItem name="import-help">
                        Import Help
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </Row>

        <Row style="margin-top:8px">
            <Table style="width:100%" :height="tableHeightToFit" size="default" draggable :columns="entriesTableColumnsConfig" :data="entriesToDisplay" border highlight-row @on-current-change="handleEntriesSelectionChanged" @on-row-dblclick="handleEditEntry">
                <template slot-scope="{ row }" slot="status"> {{ row.status | userFriendlyReferringPhysicianStatus }}</template>

                <!-- <template slot-scope="{ row }" slot="logo">
                    <img v-if="row.practiseLogo != ''" :src="row.practiseLogo" height="50px" />
                </template> -->
            </Table>
        </Row>                                        

       
        <Row style="margin-top:8px">
            <Col span="24" class="ivu-text-right">
                <Page :total="entriesTotalCount" :page-size="entriesListPageSize" :page-size-opts="[20,100,200,500,1000]" show-sizer @on-change="handleLoadEntriesListToNthPage" @on-page-size-change="handlePageLimitChanged" />
            </Col>
        </Row>
       
    </div>
</template>

<script>
const {CONFIG} = require('@/js/bntx-config')
//var axios = require("axios");
var _ = require('lodash');
import AnalyticsMgr from '@/js/AnalyticsManager.js';

const {itBnTx} = require('@/js/itBnTx')



export default {
    name: 'admin-referring-physicians',
    components: {

    },

    created () {

        // create a throttler function which will automatically manage throttling search requests to a limit, currently 1 per however many milliseconds
        this.throttledSearch = _.debounce(() => { this.handleLoadEntriesListToNthPage(1); console.log("handleThrottledSearch 600ms") }, 600, { 'leading': false })

    },

    destroyed() {

    },

    mounted() {


    },


    data () {
            return {
                physicianTitlesRefData: CONFIG.PHYSICIAN_TITLES,

                statusRefData : [
                    { statusCode : 'A', statusName: 'Active'},
                    { statusCode : 'T', statusName: 'Training Entry'},
                    { statusCode : 'M', statusName: 'Moved Address'},
                    { statusCode : 'R', statusName: 'Retired'},
                    { statusCode : 'D', statusName: 'Deceased'},
                    { statusCode : 'U', statusName: 'Unavailable'},
                ],


                entriesTableColumnsConfig: [
                    {                      title: 'Title',           key: 'title', resizable: true, sortable: true, width: 130 },
                    {                      title: 'First Name',      key: 'firstName', resizable: true, sortable: true, width: 220 },
                    {                      title: 'Last Name',       key: 'lastName', resizable: true, width: 220 },
                    // { /* slot: 'condition', */  title: 'Practice Name',           key: 'practiseName', resizable: true, minWidth: 200 },
                    {                      title: 'Address',         key: 'physicianAddress', resizable: true, width: 300 },
                    {                      title: 'Phone Number',    key: 'physicianPhone', resizable: true, width: 150 },
                    {                      title: 'Fax',             key: 'physicianFax', resizable: true, width: 150 },
                    {                      title: 'Email',           key: 'physicianEmail', resizable: true, width: 220 },
                    { slot: 'status',      title: 'Status',          key: 'status', resizable: true, width: 150 },
                ],

                throttledSearch : () => {},
                filterByFirstname: "",
                filterByLastname: "",

                entriesListIsLoading : false,
                entriesListPageSize : 20,
                entriesTableData: [],

                entriesTotalCount : 0,

                editEntryDetails: {
                                        practiseId: this.$store.state.loggedInDoctorDetails.practiseId,
                                        firstName: "",
                                        lastName: "",
                                        physicianAddress: "",
                                        physicianPhone: "",
                                        status: "A",
                                    },
                savingDetailsToBackend : false,



                liveValidating: true,
                liveValidatingFieldsOK: true,
                editEntryDetailsFieldRules : {
                    firstName: [
                        { required: true, message: 'Firstname cannot be empty', trigger: 'blur' },
                    ],
                    lastName: [
                        { required: true, message: 'Lastname cannot be empty', trigger: 'blur' },
                    ],
                    physicianAddress: [
                        { required: true, message: 'Address is required', trigger: 'blur' },
                    ],
                    physicianPhone: [
                        { required: true, message: 'Phone is required', trigger: 'blur' },
                    ],
                },



                filterFirstnameBy : '',
                filterLastnameBy : '',
                showAllStatusUsers : false,


                isCreatingNewEntry : false,
                selectedEntryDetailsBeforeCreatingNewEntry : {},      // this is used to restore the previous selection when user cancels create new entry.

                showDetails: false,
                detailsDrawerStyles: {
                    height: 'calc(100% - 55px)',
                    overflow: 'auto',
                    paddingBottom: '53px',
                    position: 'static'
                },


                showImportHelp : false,

                uploadReferrerImportCSVData : {
                    practiseId : 0,
                    authToken : '',
                    importType : "ReferringPhysician", // "Patient", "ReferringPhysician"
                },
            }
        },

    filters: {

    },
    
    computed: {

        // determine realtime whether we need to show the validation messages (thus make room for them (via css criteria))
        mandatoryFieldsStyle() { return (this.liveValidating && (this.liveValidatingFieldsOK == false)) ? "revealValidationMessages" : "" },

        entriesToDisplay() {

            return this.entriesTableData.filter(entry => {
                if (entry.referringPhysicianId == 0) return false   // dont show -- add new referrer --

                if (this.showAllStatusUsers == false && (entry.status != 'A' && entry.status != 'T')) return false   // show Active only or everyone.

                // if (entry.firstName == undefined && this.filterFirstnameBy != '') return false  // if we are searching firstname, but entry firstname if not defined or empty, we are definitely not a match.
                // if (entry.lastName == undefined && this.filterLastnameBy != '') return false  // if we are searching firstname, but entry firstname if not defined or empty, we are definitely not a match.


                // if ((entry.statusCode == 'I' || entry.statusCode == 'D') && this.showInactiveAndDeletedUsers == false) return false   // dont show inactive or deleted...

                // if ((entry.statusCode == 'I' || entry.statusCode == 'D') && this.showInactiveAndDeletedUsers == false) return false   // dont show inactive or deleted...

                // if (this.filterFirstnameBy != '' && entry.firstName != undefined && entry.firstName.toLowerCase().includes(this.filterFirstnameBy.toLowerCase()) == false) return false // remove all items that dont match our firstname filter
                // if (this.filterLastnameBy != '' && entry.lastName != undefined && entry.lastName.toLowerCase().includes(this.filterLastnameBy.toLowerCase()) == false) return false // remove all items that dont match our lastname filter

                return true
            })

        },

        confirmRemoveEntryMessage() {
            return "Are you sure you wish to remove '" 
                    + this.editEntryDetails.firstName + " "
                    + this.editEntryDetails.lastName + "' from the system?"
        },
        
        tableHeightToFit() {
            return window.innerHeight - 220
        },

        referringPhysicianImportTemplateURL() { return CONFIG.REFERRING_PHYSICIAN_IMPORT_TEMPLATE_URL() },
        uploadActionURL() { return itBnTx.baseUrl + "/rest/user/upload" },
    },
    methods: {
        visibilityChanged (isVisible, entry) {
            entry
            
            if (isVisible == true) {
                AnalyticsMgr.sendPageView('/Administration/ReferringPhysician');

                this.refreshDataForUI()
            }
        },

        refreshDataForUI() {

            this.handleLoadEntriesListToNthPage(1)

        },
        
        handlePageLimitChanged(inNewLimit) {
            this.entriesListPageSize = inNewLimit       // silly two way binding not working... so have to do this way
            this.handleLoadEntriesListToNthPage(1)
        },


        handleLoadEntriesListToNthPage(inPageNumber) {
            inPageNumber

            var loadOrSearchPromise;

            // show loading spinner
            this.entriesListIsLoading = true

            if (this.filterByFirstname != "" || this.filterByLastname != "") {
                loadOrSearchPromise = itBnTx.searchReferringPhysiciansInPractiseNoCache({
                                                inSearchFirstnameString : this.filterByFirstname,
                                                inSearchLastnameString : this.filterByLastname,
                                                inStart : this.entriesListPageSize * (inPageNumber - 1),
                                                inLimit : this.entriesListPageSize })
            } else {
                loadOrSearchPromise = itBnTx.searchReferringPhysiciansInPractiseNoCache({
                                                inStart: this.entriesListPageSize * (inPageNumber - 1),
                                                inLimit: this.entriesListPageSize})
            }
            // loadOrSearchPromise = itBnTx.searchReferringPhysiciansInPractise()

            loadOrSearchPromise.then(response => {
                
                var entries = response.data.referringPhysicians;

                this.entriesTotalCount = response.data.totalCount

                // entries.map(entry => { if (entry.userLastLogin == undefined) entry['userLastLogin'] = 0 })
                this.entriesTableData = entries;
                
                var foundEntryToHighlight = false

                if (this.editEntryDetails.referringPhysicianId != undefined) {
                    // if we previously had a selection, try to preserve the same record which was previously selected
                    var previousSelection = this.entriesToDisplay.find(entry => { return entry.referringPhysicianId == this.editEntryDetails.referringPhysicianId} )

                    // sanity check... should never happen... unless someone deletes it from another location.
                    if (previousSelection != undefined) {
                        previousSelection["_highlight"] = true
                        this.handleEntriesSelectionChanged(previousSelection, null)
                        foundEntryToHighlight = true
                    }
                }
                
                if (foundEntryToHighlight == false) {
                    // else select the first record if nothing was selected

                    // if we have at least one entry, select the first one.
                    if (this.entriesToDisplay.length != 0) {
                        this.entriesToDisplay[0]["_highlight"] = true
                        this.handleEntriesSelectionChanged(this.entriesToDisplay[0], null)
                    }
                }

            }).finally(() => {
                // hide loading spinner
                this.entriesListIsLoading = false
            })
        },
        
        
        handleEntriesSelectionChanged(currentRow, oldCurrentRow)  {
            oldCurrentRow
            
            this.editEntryDetails = {}
            
            // clear previously selected data, before loading new data.
            if (currentRow == null) {
                return
            }

            // clone data so when cancelling an edit session, we can restore the original details in UI
            this.editEntryDetails = _.cloneDeep(currentRow)

        },
        
        handleAddEntry() {
            AnalyticsMgr.sendEvent('/Administration/ReferringPhysician', 'click', 'ReferringPhysician_Add')

            this.liveValidating = false

            this.selectedEntryDetailsBeforeCreatingNewEntry = _.cloneDeep(this.editEntryDetails)

            this.editEntryDetails = {
                                        practiseId: this.$store.state.loggedInDoctorDetails.practiseId,
                                        firstName: "",
                                        lastName: "",
                                        physicianAddress: "",
                                        physicianPhone: "",
                                        status: "A",
                                    }
            this.$refs['editEntryDetailsFormFields'].resetFields()

            this.isCreatingNewEntry = true;
            this.showDetails = true

        },

        handleEditEntry() {
            AnalyticsMgr.sendEvent('/Administration/ReferringPhysician', 'click', 'ReferringPhysician_Edit')

            this.liveValidating = true

            this.checkFormMandatoryFields()

            this.isCreatingNewEntry = false
            this.showDetails = true
        },

        handleRemoveEntry() {
            AnalyticsMgr.sendEvent('/Administration/ReferringPhysician', 'click', 'ReferringPhysician_Remove')

            if (this.editEntryDetails.referringPhysicianId != undefined) {
                itBnTx.deleteReferringPhysician({inReferringPhysicianID : this.editEntryDetails.referringPhysicianId})
                      .then(response => {
                          response
                        
                          this.refreshDataForUI()

                          this.$Message.success('Successfully removed');
                      })
            }
            
        },


        checkFormMandatoryFields() {
            if (this.liveValidating) {
                this.$refs['editEntryDetailsFormFields'].validate((valid) => {
                    if (valid) {
                        this.liveValidatingFieldsOK = true
                    } else {
                        this.liveValidatingFieldsOK = false
                    }
                })
            }
        },



        handleCancelEntryDetails() {
            AnalyticsMgr.sendEvent('/Administration/ReferringPhysician', 'click', 'ReferringPhysician_Edit_Cancel')

            if (this.isCreatingNewEntry == false) {
                var previousSelection = this.entriesTableData.find(entry => { return entry.inReferringPhysicianID == this.editEntryDetails.inReferringPhysicianID} )

                // restore any changes back to what they were since the user cancelled.
                this.editEntryDetails = _.cloneDeep(previousSelection)
            } else {
                this.editEntryDetails = this.selectedEntryDetailsBeforeCreatingNewEntry
            }

            this.showDetails = false
        },

        handleSaveEntryDetails() {
            AnalyticsMgr.sendEvent('/Administration/ReferringPhysician', 'click', 'ReferringPhysician_Edit_Save')

            this.$refs['editEntryDetailsFormFields'].validate((valid) => {
                if (valid) {
                    this.liveValidatingFieldsOK = true

                    var savingDetails = this.editEntryDetails

                    // if we are a new record, make sure to clear the userId so the API knows to create a new record
                    if (savingDetails.inReferringPhysicianID == undefined) {
                        delete savingDetails.inReferringPhysicianID
                    }
                                        
                    delete savingDetails._highlight // delete UI key, otherwise API barfs

 //                   console.log("SAVE DETAILS> ", JSON.stringify(this.savingDetails));

                    this.savingDetailsToBackend = true
                    
                    var savingPromise

                    if (this.isCreatingNewEntry == true)
                        savingPromise = itBnTx.createReferringPhysician({inReferringPhysicianRecord : savingDetails })
                    else
                        savingPromise = itBnTx.updateReferringPhysician({inReferringPhysicianRecord : savingDetails })

                    savingPromise
                          .then(response => {
                                response
                                
                                AnalyticsMgr.sendEvent('/Administration/ReferringPhysician', 'api', (this.isCreatingNewEntry) ? 'ReferringPhysician_New_Success' : 'ReferringPhysician_Edit_Success')
                                
                                // reload data into UI
                                this.refreshDataForUI()
                                this.showDetails = false
                          })
                          .catch(error => {
                              AnalyticsMgr.sendEvent('/Administration/ReferringPhysician', 'api', ((this.isCreatingNewEntry) ? 'ReferringPhysician_New_Error_' : 'ReferringPhysician_Edit_Error_') + error.responseCode)
                          })
                          .finally(() => {
                              this.savingDetailsToBackend = false
                          })

                } else {
                    this.liveValidating = true
                    this.liveValidatingFieldsOK = false

                    this.$Message.error('Enter mandatory fields before trying again.');
                }
            })
        },


        handleImportMenu(inMenuName) {
            switch( inMenuName ) {
                case 'export-now':
                    AnalyticsMgr.sendEvent('/Administration/ReferringPhysician', 'click', 'ReferringPhysician_Import_Select')
                    itBnTx.searchReferringPhysiciansInPractiseNoCache({
                                    // inSearchFirstnameString = "",
                                    // inSearchLastnameString = "",
                                    // inStart = 0,
                                    inLimit : 1000000,
                                    inExport : true,
                                    inExportFormat : 'csv'
                                })
                            .then(response => {
                                var hiddenElement = document.createElement('a');
                                hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(response.data);
                                hiddenElement.target = '_blank';
                                hiddenElement.download = 'referring_physicians.csv';
                                hiddenElement.click();
                            })
                    break;
                case 'import-now':
                    AnalyticsMgr.sendEvent('/Administration/ReferringPhysician', 'click', 'ReferringPhysician_Import_Select')
                    break;
                
                case 'import-help':
                    AnalyticsMgr.sendEvent('/Administration/ReferringPhysician', 'click', 'ReferringPhysician_Import_Help')
                    this.showImportHelp = true
                    break;

            }
        },


        handleBeforeUploadCSV(inFile) {
            inFile

            this.uploadReferrerImportCSVData.practiseId = this.$store.state.loggedInDoctorDetails.practiseId
            this.uploadReferrerImportCSVData.authToken = this.$store.state.btxAuthToken

            return true
        },

        handleFormatError (file) {
            try { 
                AnalyticsMgr.sendEvent('/Administration/ReferringPhysician', 'error', 'ReferringPhysician_Import_WrongFormat_' + file.name.split('.').pop())
            } catch { console.log("oh dear") }

            this.$Notice.warning({
                title: 'The file format is incorrect',
                desc: 'File format of ' + file.name + ' is incorrect, please select a .csv file'
            });
        },
        handleMaxSize (file) {
            AnalyticsMgr.sendEvent('/Administration/ReferringPhysician', 'error', 'ReferringPhysician_Import_TooLarge')

            this.$Notice.warning({
                title: 'Exceeding file size limit',
                desc: 'File  ' + file.name + ' is too large, no more than 2M.'
            });
        },

        handleSuccess (response, file, fileList) {
            response, file, fileList
            // console.log(response)
            // console.log(file)
            // console.log(fileList)

            AnalyticsMgr.sendEvent('/Administration/ReferringPhysician', 'error', 'ReferringPhysician_Import_Success')

            itBnTx.clearCacheForKey({ inKey : 'searchReferringPhysiciansInPractise' })
            this.refreshDataForUI()

            this.$Notice.success({
                title: 'Import Successful',
                desc: response.responseMsg,
                duration: 20
            });
        },

        handleError (error, file, fileList) {
            error, fileList
            // console.log(error)
            // console.log(file)
            // console.log(fileList)

            AnalyticsMgr.sendEvent('/Administration/ReferringPhysician', 'error', 'ReferringPhysician_Import_Error')

            this.$Notice.error({
                title: 'Error Importing CSV',
                desc: file.responseMsg
            });
        },

    },

    watch : {
    // "propertyLevel1", "propertyLevel1.propertyLevel2"...
    
    }

}

/*
  debugging css:

  style="border: 2px solid red;"

*/
</script>

<style scoped>
  
.drawer-footer{
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: 1px solid #e8e8e8;
        padding: 10px 16px;
        text-align: right;
        background: #334155;

 }

.ivu-form-item {
    margin-bottom: 2px;    /* 24px */
    vertical-align: top;
    zoom: 1;
}


.revealValidationMessages {
    margin-bottom: 24px !important;    /* 24px */
}
</style>

